export const UNINITIALIZED = 'UNINITIALIZED';
export const CHOOSE_METHOD = 'CHOOSE_METHOD';

// Google Authenticator
export const REGISTER_HUBSPOT_WITH_GA = 'REGISTER_HUBSPOT_WITH_GA';
export const VERIFY_GOOGLE_AUTHENTICATOR = 'VERIFY_GOOGLE_AUTHENTICATOR';

// Hubspot App
export const REGISTER_WITH_HUBSPOT_APP = 'REGISTER_WITH_HUBSPOT_APP';

// SMS
export const REGISTER_SMS = 'REGISTER_SMS';
export const VERIFY_SMS = 'VERIFY_SMS';

// Backup codes
export const BACKUP_CODES = 'BACKUP_CODES';
export const VERIFICATION_SUCCESSFUL = 'VERIFICATION_SUCCESSFUL';